import {
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  RECEIVED_PROFILE,
  FETCH_PROFILE,
  RESET_PROFILE_STATUS,
  UPDATE_PROFILE_SWITCH,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  RESET_UPDATE_PROFILE_STATUS,
} from "./actionTypes";
import getSwitchUserStorage from "../../../helpers/getSwitchUserStorage";

const switchUserStorage = getSwitchUserStorage();
const userSwitchInitialValue = switchUserStorage
  ? {
      isUserSwitch: switchUserStorage?.isUserSwitch,
      email: switchUserStorage?.email,
      company: switchUserStorage?.company,
    }
  : { isUserSwitch: false, email: "", company: "" };

const updateSwitchUserStorage = (userSwitchData) => {
  sessionStorage.setItem("switchUser", JSON.stringify(userSwitchData));
};

const initialState = {
  error: "",
  user: {},
  userSwitch: userSwitchInitialValue,
  status: "idle", // or: 'loading', 'success', 'failed',
  updateStatus: "idle", // for profile updates
  updateError: "",
  updateSuccess: false,
};

const Profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state };
      break;
    case PROFILE_SUCCESS:
      state = {
        ...state,
        success: action.payload.status,
        user: action.payload.data,
      };
      break;
    case PROFILE_ERROR:
      state = {
        ...state,
        error: action.payload,
      };
      break;
    case FETCH_PROFILE:
      state = {
        ...state,
        status: "loading",
      };
      break;
    case RECEIVED_PROFILE:
      state = {
        ...state,
        user: action.payload,
        status: "success",
      };
      break;
    case RESET_PROFILE_STATUS:
      state = {
        ...state,
        status: "idle",
      };
      break;
    case UPDATE_PROFILE_SWITCH:
      state = {
        ...state,
        userSwitch: action.payload,
      };
      updateSwitchUserStorage(action.payload);
      break;
    case UPDATE_PROFILE:
      state = {
        ...state,
        updateStatus: "loading",
        updateError: "",
        updateSuccess: false,
      };
      break;
    case UPDATE_PROFILE_SUCCESS:
      state = {
        ...state,
        updateStatus: "success",
        updateSuccess: true,
        updateError: "",
        user: action.payload,
      };
      break;
    case UPDATE_PROFILE_ERROR:
      state = {
        ...state,
        updateStatus: "failed",
        updateError: action.payload,
        updateSuccess: false,
      };
      break;
    case RESET_UPDATE_PROFILE_STATUS:
      state = {
        ...state,
        updateStatus: "idle",
        updateError: "",
        updateSuccess: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Profile;
